
export const encodeLicenseId = (id: number): string => {
  const offset = Math.floor(Math.random() * 9000) + 1000;
  const encoded = parseInt(id.toString()) * 37 + offset;
  return `${encoded}-${offset}`;
};

export const decodeLicenseId = (encoded: string): string => {
  if (!encoded) return null;

  const parts = encoded.split('-');
  if (parts.length !== 2) return null;

  try {
    const value = parseInt(parts[0]);
    const offset = parseInt(parts[1]);
    return ((value - offset) / 37).toString();
  } catch (e) {
    console.error('Invalid license code format');
    return null;
  }
};